export interface ICheckpoint {
  id?:number;
  name?:string
  latitude?:number
  longitude?:number
  companyId?:number
  position?:number
  buttonsType?:number[]
  background?:string
  index?:number
  complete?:boolean
  date?:Date
  description?:string
  photo?:any
  registered?:number
  additionalCheckpoint?:number
}


export class Checkpoint implements ICheckpoint {
  id?: number;
  name?: string;
  latitude?: number = 0;
  longitude?: number = 0;
  companyId?: number;
  position?: number;
  buttonsType?:number[] = []
  background?: string = '#36858a94'
  index?:number
  complete?:boolean = false
  date?:Date
  description?: string;
  photo?:any
  registered?: number;
  additionalCheckpoint?:number;
}
